import axios from 'axios';

export const getCookie = (name: string) => {
	var value = '; ' + document.cookie;
	var parts: any = value.split('; ' + name + '=');
	if (parts.length === 2) return parts.pop().split(';').shift();
};

export const photoUpload = (file: [File]) => {
	const url = '/api/photos';
	const formData = new FormData();

	formData.append('file', file[0]);
	const config = {
		headers: {
			'content-type': 'multipart/form-data',
		},
	};
	return axios.post(url, formData, config);
};

export const create_UUID = () => {
	var dt = new Date().getTime();
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (
		c
	) {
		var r = (dt + Math.random() * 16) % 16 | 0;
		dt = Math.floor(dt / 16);
		return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
	});
	return uuid;
};
